/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DataChangeActionType {
  Update = 'Update',
  Add = 'Add',
  Remove = 'Remove'
}
